import React from "react";

const Bash_Chown = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Chown</h2>
      <p>Change file owner and optionally group.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>chown [owner][:group] file</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>sudo chown user file.txt
sudo chown user:group file.txt</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Requires appropriate privileges (often sudo).</p>
    </div>
  );
};

export default Bash_Chown;
